import { Component, input, model, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { noop, provideValueAccessor } from '../util';
import { ButtonWidth } from '../button';
import { BspkIcon } from '../icon';

export type SegmentedControlOption<TValue> = {
  label: string;
  value: TValue;
  disabled?: boolean;
  icon?: string;
  iconActive?: string;
};

type SegmentedControlSize = 'small' | 'medium';

@Component({
  selector: 'bspk-segmented-control',
  templateUrl: './segmented-control.component.html',
  styleUrl: './segmented-control.component.scss',
  host: {
    'data-bspk': 'segmented-control',
    '[attr.data-size]': 'size()',
    '[attr.data-width]': 'width()',
  },
  imports: [BspkIcon],
  encapsulation: ViewEncapsulation.None,
  providers: [provideValueAccessor(BspkSegmentedControl)],
})
export class BspkSegmentedControl<TValue = any> implements ControlValueAccessor {
  readonly value = model();
  readonly options = input.required<SegmentedControlOption<TValue>[]>();
  readonly size = input<SegmentedControlSize>('medium');
  readonly width = input<ButtonWidth>('hug');

  private onChange: (value: TValue) => void = noop;
  private onTouched: () => void = noop;

  handleChange(value: TValue) {
    this.value.set(value);
    this.onTouched();
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(): void {
    // noop
  }

  writeValue(obj: any): void {
    this.value.set(obj);
  }
}
